import { get } from '../api';
import ApiResponse from '../types/ApiResponse';
import { CalendarDay } from './types';

const fetchCalendar = async (url: string, { brandId }: { brandId: string }) => {
  const response = await get<ApiResponse<CalendarDay>>(url, {
    headers: {
      'Kouto-Brand-Id': brandId,
      'Way-Brand-Id': brandId,
    },
  });
  return response.data;
};

export default fetchCalendar;
